import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { environment as environmentUat } from '../../../environments/environment.uat';
import { Environment } from './models/environment.model';
import { environmentProd } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private currentHost: string;

  constructor() {
    this.currentHost = window.location.hostname;
  }

  getEnvironment(): Environment {
    if (this.currentHost === environmentUat.host) {
      return environmentUat;
    } else if (this.currentHost === environmentProd.host) {
      return environmentProd;
    }

    return environment;
  }
}